import { Text } from '@mantine/core';
import type { FC } from 'react';

type Props = {
  answerText: string;
};

const AnswerText: FC<Props> = ({ answerText }) => {
  return (
    <Text fw={450} color='black'>
      {answerText}
    </Text>
  );
};

export default AnswerText;
